import classNames from "classnames";
// import { GlutenFreePlaceRecommendations } from "@/components/molecules/GlutenFreePlaceRecommendations";
// import { TopPlaceDescription } from "@/components/atoms/TopPlaceDescription";
// import { TopPlaceTags } from "@/components/molecules/TopPlaceTags";

export const TopPlaceInformationSkeleton = () => {
    return (
        <div className=" px-4 md:px-0 box-content border-b border-zinc-200 md:border-none">
            <h1
                className={classNames({
                    'animate-pulse bg-slate-200': true,
                    'text-2xl md:text-4xl': true,
                    'w-2/3 h-10 font-bold leading-7 md:leading-10 mb-2': true,
                    // 'blur ml-3 select-none': isBlurred,
                })}
            />
            <p
                className={classNames({
                    'animate-pulse bg-slate-200': true,
                    'text-[13px] w-1/3 h-4 md:text-lg font-semibold md:font-medium leading-relaxed mb-2': true,
                    // 'blur ml-3 select-none': isBlurred,
                })}
            />
            {/*<div className="flex gap-2 flex-col-reverse md:flex-col mb-4">*/}
            {/*    <GlutenFreePlaceRecommendations count={recommendationsCount}/>*/}
            {/*    <TopPlaceDescription description={description}/>*/}
            {/*    <TopPlaceTags tags={tags}/>*/}
            {/*</div>*/}
        </div>
    );
};